import React, { useEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Navigation from './components/Navigation';
import HomePage from './pages/HomePage';
import CatalogPage from './pages/CatalogPage';
import AboutPage from './pages/AboutPage';
import Footer from './components/Footer';
import PartnershipPage from './pages/PartnershipPage';
import ContactsPage from './pages/ContactsPage';
import SupportPage from './pages/SupportPage';
import PriceListsPage from './pages/PriceListsPage';
import VideoTutorialsPage from './pages/VideoTutorialsPage';
import CallbackPage from './pages/CallbackPage';
import BimModelsPage from './pages/BimModelsPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import CartPage from './pages/CartPage';
import CheckoutPage from './pages/CheckoutPage';
import OrdersPage from './pages/OrdersPage';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import { trackHit } from './utils/metrika';

const MetrikaPageHits = () => {
  const location = useLocation();
  const isFirst = useRef(true);

  useEffect(() => {
    if (isFirst.current) {
      isFirst.current = false;
      return;
    }
    trackHit(window.location.href);
  }, [location.pathname, location.search]);

  return null;
};

const App = () => {
  return (
    <AuthProvider>
      <CartProvider>
        <Router>
          <MetrikaPageHits />
          <div className="site-shell min-h-screen flex flex-col">
            <Header />
            <Navigation />
            <main className="flex-grow pb-12">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/catalog" element={<CatalogPage />} />
                <Route path="/catalog/:categoryId" element={<CatalogPage />} />
                <Route path="/catalog/:categoryId/:subcategoryId" element={<CatalogPage />} />
                <Route path="/about/:section" element={<AboutPage />} />
                <Route path="/partnership/:type" element={<PartnershipPage />} />
                <Route path="/contacts" element={<ContactsPage />} />
                <Route path="/support" element={<SupportPage />} />
                <Route path="/price-lists" element={<PriceListsPage />} />
                <Route path="/video-tutorials" element={<VideoTutorialsPage />} />
                <Route path="/callback" element={<CallbackPage />} />
                <Route path="/bim-models" element={<BimModelsPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/cart" element={<CartPage />} />
                <Route path="/checkout" element={<CheckoutPage />} />
                <Route path="/orders" element={<OrdersPage />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </Router>
      </CartProvider>
    </AuthProvider>
  );
};

export default App;
